import React, {useState} from 'react'
import icons from "../helpers/icons";

const HundMetadata = ({hund}) => {
    const [display, toggleDisplay] = useState(false);
    const Tittles = Object.keys(hund)
        .map(key => {
            let result = null;
            const value = hund[key];
            if (value !== null && value.length > 0 && key.startsWith('tittel') && key.length > 'tittel'.length) {
                result = <div key={value}><img className="icon score-black" src={icons.score} alt="" /> {key === 'tittel3' && value !== null && <span>Andre titler: </span>}{value}</div>
            }
            return result
        }).filter(k => k != null);

    let tittel1Og2 = null;
    if (hund.tittel1 !== null) {
        tittel1Og2 = hund.tittel1;
    }
    if (hund.tittel2 !== null) {
        if (tittel1Og2 !== null) {
            tittel1Og2 += " ";
        } else {
            tittel1Og2 = "";
        }
        tittel1Og2 += hund.tittel2;
    }
    if (tittel1Og2 == null && hund.tittel3 !== null) tittel1Og2 = hund.tittel3;
    return (
        <div onClick={() => toggleDisplay(!display)} className="dog-title-container">
            {   tittel1Og2 &&
                <>
                    <span className='dog-title'>
                            <img className="icon score-black" src={icons.score} alt="" />
                            <span className="title-text">
                                {tittel1Og2}
                            </span>
                    </span>
                    <span >
                        <img className="icon arrow-title"
                             data-open={display}
                             src={icons.acd}
                             alt="" />
                    </span>
                    { display && <div className="dog-titles"> {Tittles}</div> }
                </>
            }
        </div>
    )
}

export default HundMetadata;
